(function ($, Drupal) {
  'use strict';

  // Check for events filter
  $('#event-types li a').click(function (event) {
    event.preventDefault();
    var $selectedItem = jQuery(this);
    jQuery('#field_event_type_target_id').val($selectedItem.data('event-value'));
    $('#views-exposed-form-events-events').submit();
  });

  $('#all-months li a').click(function (event) {
    event.preventDefault();

    var $selectedItem = jQuery(this);

    jQuery('#date_min').val($selectedItem.data('event-min'));
    jQuery('#date_max').val($selectedItem.data('event-max'));

    $('#views-exposed-form-events-events').submit();
  });

})(jQuery);